// extracted by mini-css-extract-plugin
module.exports = {"comments":"comments--93VrJ","title":"title--qoLia","input":"input--+ZLqd","wrapper":"wrapper--WIWqr","item":"item--6qpPm"};